import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaReact, FaPython, FaJs, FaCss3, FaDownload } from "react-icons/fa";
import DownloadButton from './DownloadCv';
import { DiDjango } from "react-icons/di";
import { useTheme } from '../theme/ThemeContext';
import { useClick } from './ClickContext';

  
   


const LeftBanner = () => {
  const {click} = useClick();
  const {darkTheme} = useTheme();
    const [text] = useTypewriter({
      words: ["Freelancer.", " Developer"],
      loop: true,
      typeSpeed: 70,
      deleteSpeed: 60,
      delaySpeed: 2100,
    });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className={darkTheme?"text-lg font-normal":"text-black font-normal"}>WELCOME TO MY PORTFOLIO</h4>
        <h1 className={darkTheme?"text-6xl font-bold text-white":"text-6xl font-bold text-black"}>
          Hi, I'm <span className={darkTheme?"text-designColor capitalize":"text-designColor capitalize"}>Rootchy</span>
        </h1>
        <h2 className={darkTheme?"text-4xl font-bold text-white":"text-4xl font-bold text-black"}>
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="green"
          />
        </h2>
        <p className={darkTheme?"text-base font-bodyFont leading-6 tracking-wide":"text-black font-bodyFont leading-6 tracking-wide"}>
        I am a web developer proficient in Python Django, HTML5, CSS3, JavaScript and
        ReactJS,able to create enhanced user experiences through strategic animation.
        </p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className={darkTheme?"text-base uppercase font-titleFont mb-4":"text-black uppercase font-titleFont mb-4"}>
            Find me in
          </h2>
          <div className="flex gap-4">
        
            <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
          <a href="https://twitter.com/rootchy">
            <FaTwitter />
          </a>

          </span>
          <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
            <a href="https://www.linkedin.com/in/rootchymad/">
            <FaLinkedinIn />
            </a>
          </span>
        
          </div>
        </div>
        <div>
          <h2 className={darkTheme?"text-base uppercase font-titleFont mb-4":"text-black uppercase font-titleFont mb-4"}>
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
            <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
              <FaReact />
            </span>
            <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
              <FaJs />
            </span>
            <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
              <FaPython />
            </span>
            <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
              <DiDjango />
            </span>
            <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
              <FaCss3 />
            </span>
          </div>
        </div>
      </div>
      <span className={darkTheme?"bannerDownloadButton":"bannerDownloadButton2"}>
        {!click && <FaDownload />}
      <DownloadButton />
      </span>
    </div>
  );
}

export default LeftBanner